import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { NavigateEvaluationService } from 'src/app/navigate-evaluation.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-evaluation-list',
  templateUrl: './evaluation-list.component.html',
  styleUrls: ['./evaluation-list.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class EvaluationListComponent implements OnInit {
  [x: string]: any;
  public showSpinner = true;
  private currentPage = 'evaluation-list';
  private previousPage: string | null = null;
  evaluations: any[] = [];
  evaluate: any[] = [];
  searchEvaluation: any[] = [];
  evaluate2: any[] = [];
  date = new Date();
  model: any = {};
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  user_id: any;
  first_name: any;
  last_name: any;
  user_role: any;
  searchText: any;
  searchDesignation: any;
  constructor(private router: Router,
    private navigationEvaluationService: NavigateEvaluationService,
    private evaluationService: EvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private datePipe: DatePipe) {
    this.model = {
      month_int: this.date.getMonth() + 1,
      month_char: this.datePipe.transform(this.date.setMonth(this.date.getMonth()), "MMMM"),
      month_year: this.date.getFullYear(),
    }
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.user_role.team_evaluation
    if (this.user_role.role_type == "Admin_AND_Team_Lead" || this.user_role.role_type == "Team_Lead") {
      this.router.navigate(['/evaluation-yearly']);
    } else if (this.user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
    this.user_detail();
  }
  ngOnInit(): void {
    this.getAllEvaluationByAdmin(this.model);

    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  filterEvaluationsByName() {
    this.searchDesignation = '';
    if (this.searchText !== '' && this.searchText !== undefined && this.searchText !== null) {

      this.evaluate = this.evaluations.filter(data =>
        data.first_name.toLowerCase().includes(this.searchText.toLowerCase())
        ||
        data.last_name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    else {
      this.evaluate = this.evaluations;
    }
  }
  filterEvaluationsByDesignation() {
    this.searchText = '';
    if (this.searchDesignation !== '' && this.searchDesignation !== undefined && this.searchDesignation !== null) {

      this.evaluate = this.evaluations.filter(data =>
        data.description.toLowerCase().includes(this.searchDesignation.toLowerCase())
      );
    }
    else {
      this.evaluate = this.evaluations;
    }
  }

  filterPMpending(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithP = this.evaluate.filter(item => item.evaluation === null || item.evaluation.pm_points === '0');
    this.evaluate = evaluationsWithP;
  }
  filterPMAdd(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.evaluation !== null && item.evaluation.pm_points > '0' && item.evaluation.is_evaluation === '0');
    this.evaluate = evaluationsWithPoints;
  }
  filterPMpublished(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.evaluation !== null && item.evaluation.is_evaluation === '1');
    this.evaluate = evaluationsWithPoints;
  }
  filterTLpending(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithP = this.evaluate.filter(item => item.evaluation === null || item.evaluation.points === '0');
    this.evaluate = evaluationsWithP;
  }
  filterTLPublish(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.evaluation !== null && item.evaluation.points > '0');
    this.evaluate = evaluationsWithPoints;
  }
  filterReset(): void {
    this.searchText = '';
    this.searchDesignation = '';
    this.evaluate = this.evaluations;
  }
  selectedOption = '';
  callFunction() {
    switch (this.selectedOption) {
      case 'TLpending':
        this.filterTLpending();
        break;
      case 'TLPublish':
        this.filterTLPublish();
        break;
      case 'PMpending':
        this.filterPMpending();
        break;
      case 'PMadd':
        this.filterPMAdd();
        break;
      case 'PMpublished':
        this.filterPMpublished();
        break;
      case 'filterReset':
        this.filterReset();
        break;
      default:
        break;
    }
  }
  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_evaluation?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;

      case "add":
        return values?.add ?? false;

      case "update":
        return values?.update ?? false;


      default:
        return false;
    }
  }
  // isavailablefeature(type: string): boolean {
  //   switch (type) {
  //     case "view":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.team_evaluation.data.values.view === false
  //     case "add":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.team_evaluation.data.values.add === false
  //     default:
  //       return false;


  //   }
  //   return false
  // }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  onReset(form: NgForm) {
    form.reset();
    this.getAllEvaluationByAdmin(this.model);
  }

  onSubmit(form: NgForm) {
    const formData = form.value;
    const date = new Date(formData.date);
    this.model = {
      month_int: date.getMonth() + 1,
      month_char: this.datePipe.transform(date, "MMMM"),
      month_year: date.getFullYear()
    };

    this.getAllEvaluationByAdmin(this.model);
  }

  addEvaluation(data: any) {
    this.user_id = data.id;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.navigationEvaluationService.previousRoute = this.router.url;

    this.router.navigate(['/user-evaluation'], {

      queryParams: {
        data: JSON.stringify(data),
        id: JSON.stringify(this.user_id),
        first_name: this.first_name,
        last_name: this.last_name
      },
      skipLocationChange: true,
    });
  }
  getAllEvaluationByAdmin(model: any) {
    this.showSpinner = true
    this.evaluationService.getAllUsersEvaluationAdmin(model).then(response => {
      if (response.success) {

        this.showSpinner = false
        this.evaluations = response.data;
        this.evaluate = this.evaluations;
        this.evaluations.forEach((data: any) => {
          if (data.evaluation != null) {
            data.percentage = data.evaluation.points + "/10";
            const dataForSorting = data.evaluation.points;
            data.percentage1 = data.evaluation.pm_points + "/10";
            const bandPercentage = (data.evaluation.points / 10) * 100;
            data.bands = bandPercentage <= 25 ? 1 : bandPercentage > 25 && bandPercentage <= 50 ? 2
              : bandPercentage > 50 && bandPercentage <= 75 ? 3 : 4

          }
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  conform() {
    const publish = 1;
    this.evaluationService.published(publish).then(response => {
      if (response.success) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  navigateToAllUsersEvaluation() {
    this.router.navigate(['/all-users-evaluation']);
  }

}
